import { useState, useEffect } from "react"

/* Single source of truth for the platform theme. Persists to
 * localStorage('theme') and toggles `<html class="dark">`. Light is the
 * default. The no-flash inline script in index.html applies the class
 * before React mounts, so first paint matches the stored preference. */
export function useDarkMode() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window === "undefined") return false
    try {
      const stored = localStorage.getItem("theme")
      if (stored) return stored === "dark"
    } catch {
      /* localStorage unavailable — fall through to light */
    }
    return false
  })

  useEffect(() => {
    const root = document.documentElement
    if (isDark) {
      root.classList.add("dark")
    } else {
      root.classList.remove("dark")
    }
    try {
      localStorage.setItem("theme", isDark ? "dark" : "light")
    } catch {
      /* non-fatal */
    }
  }, [isDark])

  const toggle = () => setIsDark((prev) => !prev)
  const setLight = () => setIsDark(false)
  const setDark = () => setIsDark(true)

  return { isDark, toggle, setLight, setDark }
}
